export default __webpack_public_path__ + "static/media/Video.1701121c.svg";